<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Cadastro domiciliar - Inconsistências"
    >
        <template v-if="data">

            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />

            <rkm-area
                title="Endereço"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Tipo de logradouro"
                            :value="data.endereco.campos.tipoLogradouroNumeroDne"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Logradouro"
                            :value="data.endereco.campos.nomeLogradouro"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Bairro"
                            :value="data.endereco.campos.bairro"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="CEP"
                            :value="data.endereco.campos.cep"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Número"
                            :value="data.endereco.campos.numero"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Sem número"
                            :value="data.endereco.campos.stSemNumero"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Complemento"
                            :value="data.endereco.campos.complemento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="5">
                        <Item
                            label="Ponto de referência"
                            :value="data.endereco.campos.pontoReferencia"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.endereco.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <Item
                            label="UF"
                            :value="data.endereco.campos.numeroDneUf"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Latitude"
                            :value="data.endereco.campos.latitude"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Longitude"
                            :value="data.endereco.campos.longitude"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Telefone"
                            :value="data.endereco.campos.telefoneContato"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Microárea"
                            :value="data.endereco.campos.microArea"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Fora de área"
                            :value="data.endereco.campos.stForaArea"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.endereco.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Recusa do cadastro domiciliar da atenção básica"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="">
                        <Item
                            label="Usuário recusou o cadastro por meio do termo de Recusa do Cadastro"
                            :value="data.recusaCadastro.campos.statusTermoRecusa"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.recusaCadastro.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Residência"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Tipo do imóvel"
                            :value="data.residencia.campos.tipoDeImovel"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Situação"
                            :value="data.residencia.campos.situacaoMoradiaPosseTerra"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Zona"
                            :value="data.residencia.campos.localizacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Tipo de domicílio"
                            :value="data.residencia.campos.tipoDomicilio"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <Item
                            label="Moradores"
                            :value="data.residencia.campos.nuMoradores"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <Item
                            label="Cômodos"
                            :value="data.residencia.campos.nuComodos"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Situação rural"
                            :value="data.residencia.campos.areaProducaoRural"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Tipo de acesso ao domicílio"
                            :value="data.residencia.campos.tipoAcessoDomicilio"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Material predominante - paredes externas"
                            :value="data.residencia.campos.materialPredominanteParedesExtDomicilio"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Disponibilidade de energia elétrica"
                            :value="data.residencia.campos.stDisponibilidadeEnergiaEletrica"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Abastecimento de água"
                            :value="data.residencia.campos.abastecimentoAgua"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Tratamento de água"
                            :value="data.residencia.campos.aguaConsumoDomicilio"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Destino do lixo"
                            :value="data.residencia.campos.destinoLixo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Forma de escoamento sanitário"
                            :value="data.residencia.campos.formaEscoamentoBanheiro"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Possui animais?"
                            :value="data.residencia.campos.stAnimaisNoDomicilio"
                        />
                    </rkm-col>

                    <rkm-col cols="7">
                        <Item
                            label="Animais"
                            :value="data.residencia.campos.animaisNoDomicilio"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Quantidade"
                            :value="data.residencia.campos.quantosAnimaisNoDomicilio"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.residencia.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Profissional responsável pelo cadastro"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissional.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissional.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissional.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissional.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="INE"
                            :value="data.profissional.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissional.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data"
                            :value="data.profissional.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissional.inconsistencias" />
            </rkm-area>

            <rkm-area
                v-if="data.residencia.campos.showResidentes"
                title="Residentes"
                type="fieldset"
            >
                <rkm-table
                    hide-filters
                    hide-pagination
                    :items="data.residentes.lista"
                    :fields="[
                        { key: 'nome', label: 'Nome' },
                        { key: 'dataNascimentoResponsavel', label: 'Data de nascimento' },
                        { key: 'numeroCnsResponsavel', label: 'CNS' },
                        { key: 'cpfResponsavel', label: 'CPF' },
                        { key: 'numeroMembrosFamilia', label: 'Número de membros da família' },
                        { key: 'numeroProntuario', label: 'Prontuário' },
                        { key: 'rendaFamiliar', label: 'Renda familiar' },
                    ]"
                />

                <Inconsistencia :inconsistencias="data.residentes.inconsistencias" />
            </rkm-area>

            <rkm-area
                v-if="data.residencia.campos.showInstituicaoPermanencia"
                title="Instituição de permanência"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            label="Nome da instituição de permanência"
                            :value="data.instituicaoPermanencia.campos.nomeInstituicaoPermanencia"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            label="Existem outros profissionais de saúde vinculados à instituição (não inclui profissionais da rede pública de saúde)?"
                            :value="data.instituicaoPermanencia.campos.stOutrosProfissionaisVinculados"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.instituicaoPermanencia.inconsistencias" />

                <rkm-area title="Identificação do responsável técnico da instituição de permanência">
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                label="Responsável técnico pela instituição"
                                :value="data.instituicaoPermanencia.campos.identificacaoResponsavelTecnico.campos.nomeResponsavelTecnico"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                label="CNS do responsável"
                                :value="data.instituicaoPermanencia.campos.identificacaoResponsavelTecnico.campos.cnsResponsavelTecnico"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                label="Cargo na instituição"
                                :value="data.instituicaoPermanencia.campos.identificacaoResponsavelTecnico.campos.cargoInstituicao"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                label="Telefone de contato"
                                :value="data.instituicaoPermanencia.campos.identificacaoResponsavelTecnico.campos.telefoneResponsavelTecnico"
                            />
                        </rkm-col>
                    </rkm-row>

                    <Inconsistencia :inconsistencias="data.instituicaoPermanencia.campos.identificacaoResponsavelTecnico.inconsistencias" />
                </rkm-area>
            </rkm-area>
        </template>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        inconsistenciaVersao(){

            const texto = this.inconsistencia?.inconsistencia || ''
      
            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`        
            ]
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },
    
        extrairVersao(texto){
            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
    },
    mixins: [repository, error]
}
</script>